import React from 'react';
import '../Toggles/toogles.css';
import './styles.css';
import useVideoContext from '../../../hooks/useVideoContext';
import { useVideoRoomI18nProvider, VideoRoomI18nMessage } from '../../../components/VideoRoomI18n';
import { WarningRed, White } from '../../../utils/colors';
import Tooltip from '../Tooltip';
export default function EndCallButton() {
  var _useVideoContext = useVideoContext(),
      room = _useVideoContext.room,
      onControlEvent = _useVideoContext.onControlEvent;

  var _useVideoRoomI18nProv = useVideoRoomI18nProvider(),
      format = _useVideoRoomI18nProv.format;

  var onClick = function onClick() {
    onControlEvent('disconnect');
    room.disconnect();
  };

  return /*#__PURE__*/React.createElement(Tooltip, {
    title: /*#__PURE__*/React.createElement("span", {
      className: "tooltip-title"
    }, format(VideoRoomI18nMessage.end_call))
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    className: "end-call-button",
    id: "end-call-button",
    style: {
      borderColor: WarningRed,
      WebkitTextFillColor: WarningRed,
      color: WarningRed,
      backgroundColor: White
    }
  }, format(VideoRoomI18nMessage.cta_bye)));
}